import React, { useState } from "react";
import Icons from "../../atoms/icons";
import { Row, Col, Tooltip } from "reactstrap";
import { DEFAULT_NODE_ICON } from "../../../constants";
import "./nodeInnerCustom.css";
import NodeIcon from "../../node-icons";
import { WorkflowCustomCallbacks } from "../../atoms/workflow-custom-callbacks";
import { NODE_NAMES } from "../../../utils/nodeTypes";
import { t } from "../../../utils/utils";
function NodeInnerCustom({ node, config }) {
  // default values
  let defaultIcon = DEFAULT_NODE_ICON;
  //
  const [popoverOpen, setPopoverOpen] = useState(false);
  const togglePopover = () => {
    setPopoverOpen(!popoverOpen);
  };
  const textStyle = {
    //estilo del texto interior del nodo
    fontSize: "12px",
    padding: "10px",
    fontWeight: 500,
    textAlign: "center",
    width: "70px",
  };
  let marginInnerTextTop = "15px";
  if (node.properties && node.properties.style && node.properties.style.icon) {
    const { icon } = node.properties.style;
    if (typeof icon === "object") {
      defaultIcon = icon.node;
    } else if (typeof icon === "string") {
      defaultIcon = icon;
    }
  }
  if (
    node.properties &&
    node.properties.style &&
    node.properties.style.textStyle
  ) {
    for (const prop in node.properties.style.textStyle) {
      if (prop !== "marginInnerTextTop")
        textStyle[prop] = node.properties.style.textStyle[prop];
      else {
        marginInnerTextTop = node.properties.style.textStyle[prop];
      }
    }
  }
  return (
    <WorkflowCustomCallbacks.Consumer>
      {(callback) => (
        <>
          {defaultIcon !== "none" ? (
            <div className="nodeIconWrapper">
              <div className="iconPosition">
                <NodeIcon draggable={false} icon={defaultIcon} width={40} />
              </div>
            </div>
          ) : (
            ""
          )}
          <div style={{ marginLeft: defaultIcon !== "none" ? "37%" : "" }}>
            <Row>
              <Col md={8}>
                <div style={textStyle}>
                  <p style={{ marginTop: marginInnerTextTop }}>
                    {node.properties.name
                      ? node.properties.name
                      : t(NODE_NAMES[node.type].name)}
                  </p>
                </div>
              </Col>
              {defaultIcon !== "none" ? (
                <Col md={4}>
                  <div className="nodeSettingWrapper ">
                    <div>
                      <a
                        href={"#node"}
                        onClick={(e) => {
                          e.stopPropagation();
                          callback.editPropertyNode(node);
                        }}
                      >
                        <Icons
                          Icon="MdSettings"
                          Config={{ color: "#003e60", size: "1.2em" }}
                        />
                      </a>
                    </div>

                    <div style={{ marginTop: "27px" }}>
                      <a href={"#node"} id={"Tooltip-" + node.id}>
                        <Icons
                          Icon="MdInfo"
                          Config={{ color: "#003e60", size: "1.2em" }}
                        />
                      </a>
                      <Tooltip
                        placement={"bottom"}
                        isOpen={popoverOpen}
                        target={"Tooltip-" + node.id}
                        toggle={togglePopover}
                        hideArrow={true}
                      >
                        {node.properties.nodeInfo &&
                        node.properties.nodeInfo.description
                          ? t(node.properties.nodeInfo.description)
                          : "no description"}
                      </Tooltip>
                    </div>
                  </div>
                </Col>
              ) : (
                ""
              )}
            </Row>
          </div>
        </>
      )}
    </WorkflowCustomCallbacks.Consumer>
  );
}
export default NodeInnerCustom;
